import { tm } from '../tm'
import { FranceSvg } from './FranceSvg'
import i18n from './i18n'
import { OutreMerSvg } from './OutreMerSvg'
import { WorldSvg } from './WorldSvg'
import type { Locales, Region } from '@captaincause/types'

interface MapProps {
  highlight: Region[]
  label: keyof (typeof i18n)['fr']
  type: 'france' | 'outreMer' | 'international'
  className?: string
  locale: Locales
}

export function Map({
  highlight,
  label,
  type,
  locale,
  className = undefined,
}: MapProps) {
  if (highlight.length === 0) return null

  const t = i18n[locale]

  let Component = WorldSvg
  if (type === 'france') Component = FranceSvg
  if (type === 'outreMer') Component = OutreMerSvg

  return (
    <div
      className={tm(
        'flex flex-col items-center justify-start',
        (type === 'france' || type === 'outreMer') && 'max-w-[112px]',
      )}
    >
      <Component
        highlight={highlight}
        className={tm('mb-1 h-fit w-full', className)}
      />
      <div className="w-full text-center text-sm">{t[label] ?? label}</div>
    </div>
  )
}
